export const compareDates = (dateA, dateB) => {
	return dateA.getTime() - dateB.getTime();
};
